import React, { useState, useEffect } from 'react';
import Layout from "../adminComponents/Layout";
import API from "../adminAPI";
import helper from "../helper";

const UploadDataPage = () => {
    const initialItem = {
        path: "",
        file: null
    };

    const MAX_FILE_SIZE = 150 * 1024 * 1024;

    const [fileItem, setFileItem] = useState(initialItem);
    const [loading, setLoading] = useState(false);
    const [statusText, setStatusText] = useState("");

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (loading) {
                e.preventDefault();
                e.returnValue = '';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [loading]);

    const isValidFile = (file) => {
        if (!file) return false;

        const is7z =
            file.type === 'application/x-7z-compressed' ||
            file.name.toLowerCase().endsWith('.7z');

        if (!is7z) {
            alert('Only .7z files are allowed');
            return false;
        }

        if (file.size > MAX_FILE_SIZE) {
            alert('File size must be less than 150 MB');
            return false;
        }

        return true;
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && isValidFile(file)) {
            setFileItem({ ...fileItem, file: file, path: file.name });
        } else {
            e.target.value = null;
            setFileItem(initialItem);
        }
    };

    const uploadToS3 = async (file) => {
        try {
            setLoading(true);
            setStatusText("Uploading to S3...");

            const response = await API.get('/admin/upload_data');
            const { url } = response.data;

            const headers = {
                'Content-Type': 'application/x-7z-compressed'
            };

            const uploadResponse = await fetch(url, {
                method: 'PUT',
                body: file,
                headers: headers
            });

            if (!uploadResponse.ok) {
                throw new Error();
            }

            setStatusText("Uploading to website...");

            const postResponse = await API.post('/admin/upload_data', {}, {
                timeout: 60 * 60 * 1000
            });

            if (postResponse.status === 200) {
                setStatusText("Upload completed successfully");
            } else {
                throw new Error();
            }
        } catch (e) {
            setStatusText("Error during upload");

            let msg = "Error during upload";

            if (e.response && e.response.data) {
                if (typeof e.response.data === "string") {
                    msg = e.response.data;
                } else if (e.response.data.error) {
                    msg = e.response.data.error;
                }
            }

            alert(msg);
        } finally {
            setFileItem(initialItem);
            document.getElementById("fileInput").value = null;

            setTimeout(() => {
                setLoading(false);
                setStatusText("");
            }, 1500);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!fileItem.file) {
            alert('Please select a file to upload');
            return;
        }

        if (!isValidFile(fileItem.file)) {
            return;
        }

        uploadToS3(fileItem.file);
    };

    const handleDownloadClick = () => {
        window.open(
            API.defaults.baseURL + "/admin/upload_data/template?jwt=" + localStorage.getItem(helper.ADMIN_TOKEN),
            "_blank"
        );
    };

    return (
        <Layout>
            {loading && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            padding: '30px 40px',
                            borderRadius: '8px',
                            fontSize: '18px'
                        }}
                    >
                        {statusText}
                    </div>
                </div>
            )}

            <section className="categories" style={{ minHeight: '100vh' }}>
                <div className="container">
                    <div className="categories-add">
                        <h3 className="categories-add__title">Upload Data</h3>
                        <form
                            className="categories-add__form"
                            onSubmit={handleSubmit}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '20px'
                            }}
                        >
                            <div
                                className="categories-add__block"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: '20px'
                                }}
                            >
                                <div
                                    className="empty-space"
                                    style={{
                                        width: '150px',
                                        height: '100px'
                                    }}
                                />

                                <label
                                    className="categories-add__label"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        position: 'relative',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <input
                                        className="categories-add__file"
                                        type="file"
                                        onChange={handleFileChange}
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            opacity: 0,
                                            cursor: 'pointer'
                                        }}
                                        id="fileInput"
                                    />
                                    <div
                                        className="categories-add__file-preview"
                                        style={{
                                            width: '200px',
                                            height: '100px',
                                            border: `2px dashed ${fileItem.file ? '#4CAF50' : '#ccc'}`,
                                            borderRadius: '4px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            padding: '10px',
                                            boxSizing: 'border-box',
                                            backgroundColor: fileItem.file ? '#e8f5e9' : 'transparent',
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {fileItem.path ? (
                                            <p
                                                className="categories-add__file-name"
                                                style={{
                                                    marginBottom: '10px',
                                                    fontSize: '14px',
                                                    color: '#333'
                                                }}
                                            >
                                                {fileItem.path}
                                            </p>
                                        ) : (
                                            <p
                                                className="categories-add__text"
                                                style={{
                                                    fontSize: '14px',
                                                    color: '#666'
                                                }}
                                            >
                                                Click to select a file
                                            </p>
                                        )}
                                    </div>
                                </label>

                                <div
                                    className="empty-space"
                                    style={{
                                        width: '50px',
                                        height: '100px'
                                    }}
                                />

                                <div
                                    className="categories-add__buttons"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '10px'
                                    }}
                                >
                                    <button
                                        className="g-add"
                                        type="submit"
                                        style={{
                                            padding: '10px 20px',
                                            fontSize: '16px',
                                            border: 'none',
                                            backgroundColor: '#060606',
                                            color: 'white',
                                            borderRadius: '4px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Upload
                                    </button>

                                    <button
                                        className="g-add"
                                        type="button"
                                        style={{
                                            padding: '10px 20px',
                                            fontSize: '16px',
                                            border: '1px solid #ddd',
                                            backgroundColor: 'white',
                                            color: '#060606',
                                            borderRadius: '4px',
                                            cursor: 'pointer'
                                        }}
                                        onClick={handleDownloadClick}
                                    >
                                        Download template
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default UploadDataPage;
